module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[111]476.105c20d.woff2";